export const profileModalTitle = 'General information'
export const profileModalSubtitle = 'First, we need to know a little bit about you'
export const roomModalTitle = 'Update details'
export const roomModalSubtitle = 'First, we need to know a little bit about what you’re looking for'
export const newRoomModalTitle = 'New private group'
export const newRoomModalSubtitle = 'First we need to know a little bit about the group'
export const sharedModalTitle = 'Invite your friends to Investium'
export const sharedModalSubtitle = 'Enter their emails here and we’ll send them an invite'
